import React, { useEffect, useMemo, useState } from "react";
import {
  MaterialReactTable,
  MRT_RowSelectionState,
  useMaterialReactTable,
  type MRT_ColumnDef,
} from "material-react-table";
import "./Tablecontent.css";
import ViewNotification from "../../modal/ViewNotify/ViewNotification";
import DeleteNotification from "../../modal/DeleteNotify/DeleteNotification";
import { Tooltip } from "antd";
import ActionButtons from "./ActionButtons";
import FilterPopup from "../../modal/CloumnFilter/FilterPopup";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux-store/store";
import {
  INotificationTableList,
  NotificationActions,
} from "../../../../slices/NotificationSlice";
import RecallNotifications from "../../modal/RecallNotify/RecallNotification";
import AssignNotification from "../../modal/AssignNotify/AssignNotification";
import { SearchFilterSort } from "../../../searchFilter/SearchFilterSort.Component";
import { DBTilte } from "../../modal/CloumnFilter/ExtensiveFilterContent";
import { useNotificationColumns } from "./ColumnContent";

// import UpdateModal from './Modal/UpdateModal';

interface TableProps {
  isUpdate: () => void;
}

const TableContent: React.FC<TableProps> = ({ isUpdate }) => {
  const {
    MultipleAssign,
    IsAssigned,
    tableData,
    enableAssign,
    HandleDeletePopup,
    HandleViewPopup,
    enableRecall,
    selectedRowData,
    GlobalLevel,
    searchFilter,
  } = useSelector((state: RootState) => state.notification);

  const columnSearch = useSelector(
    (state: RootState) => state.notification.searchFilter.columnSearch
  );

  const apiQuery = useSelector(
    (state: RootState) => state.notification.searchFilter.apiQuery
  );

  const loader = useSelector(
    (state: RootState) => state.notification.api.isLoading
  );

  const dispatch = useDispatch<AppDispatch>();
  const [enableViewNotification, setEnableViewNotification] =
    useState<boolean>(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [enableDeleteModal, setEnableDeleteModal] = useState<boolean>(false);
  const [enableAssignUser, setEnableAssignUser] = useState<boolean>(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [enableRecallAction, setEnableRecallAction] = useState<boolean>(false);
  const [sortConfig, setSortConfig] = useState({
    field: "",
    isAscending: true,
  });

  // useEffect(() => {
  //   dispatch(GetAllNotification_M3(apiQuery));
  // }, []);

  useEffect(() => {
    setIsRefetching(loader);
  }, [loader]);

  useEffect(() => {
    setEnableAssignUser(enableAssign);
  }, [enableAssign]);

  useEffect(() => {
    setEnableRecallAction(enableRecall);
  }, [enableRecall]);

  useEffect(() => {
    setEnableDeleteModal(HandleDeletePopup);
  }, [HandleDeletePopup]);

  useEffect(() => {
    setEnableViewNotification(HandleViewPopup);
  }, [HandleViewPopup]);

  //handle Edit option active to modal open and set false to editoption
  const handleUpdateNotification = (): void => {
    isUpdate();
  };

  // Initialize row selection from Redux
  useEffect(() => {
    const initialSelection: MRT_RowSelectionState = {};
    Object.keys(selectedRowData).forEach((id) => {
      initialSelection[id] = true;
    });
    setRowSelection(initialSelection);
  }, []); // Only on mount

  // Handle row selection changes
  useEffect(() => {
    const selectedRows = Object.keys(rowSelection).reduce((acc, rowId) => {
      const foundRow = tableData.find((row) => row.notificationID === rowId);
      if (foundRow) {
        acc[rowId] = foundRow;
      } else if (selectedRowData[rowId]) {
        // Keep previously selected rows that aren't on the current page
        acc[rowId] = selectedRowData[rowId];
      }
      return acc;
    }, {} as { [key: string]: INotificationTableList });

    dispatch(NotificationActions.UpdateSelectedRowData(selectedRows));
    dispatch(NotificationActions.UpdateMultipleAssign(selectedRows));
  }, [rowSelection, tableData]);

  const handleSorting = (field: string) => {
    setSortConfig((prevConfig) => {
      let fieldName = "";
      let newIsAscending = false;

      if (apiQuery.sortField?.length > 0) {
        if (apiQuery.sortField === field) {
          if (apiQuery.isAscending === false) {
            fieldName = "";
            newIsAscending = false;
          } else {
            fieldName = apiQuery.sortField;
            newIsAscending = false;
          }
        } else {
          fieldName = field;
          newIsAscending = true;
        }
      } else {
        fieldName = field;
        newIsAscending = true;
      }

      dispatch(
        NotificationActions.UpdateSorting({
          isAscending: newIsAscending,
          sortField: fieldName,
        })
      );

      return {
        field: fieldName,
        isAscending: newIsAscending,
      };
    });
  };

  // const columns = useMemo<MRT_ColumnDef<INotificationTableList>[]>(
  //   () => [
  //     {
  //       accessorKey: "nUniqueID",
  //       header: "",
  //       grow: false,
  //       maxSize: 90,
  //       Header: () => (
  //         <div className="notify-table-align">
  //           <span>Notification ID</span>
  //           <SearchFilterSort
  //             fieldName={DBTilte.NUniqueID}
  //             currentSortFieldName={apiQuery.sortField}
  //             isAscending={apiQuery.isAscending}
  //             onClick={handleSorting}
  //           />
  //           <FilterPopup
  //             isFilter={searchFilter.tempColumnSearch.NUniqueID.isFiltered}
  //             searchField="Notification Unique ID"
  //             accessorKey="uniqueId"
  //           />
  //         </div>
  //       ),
  //       Cell: ({ cell }) => (
  //         <span className="table-row-content">{cell.getValue<string>()}</span>
  //       ),
  //     },
  //     {
  //       accessorKey: "title",
  //       header: "",
  //       grow: false,
  //       maxSize: 250,
  //       Header: ({ column }) => (
  //         <div className="notify-table-align">
  //           <div>
  //             <span>Title</span>
  //             <SearchFilterSort
  //               fieldName={DBTilte.title}
  //               currentSortFieldName={apiQuery.sortField}
  //               isAscending={apiQuery.isAscending}
  //               onClick={handleSorting}
  //             />
  //           </div>
  //           <FilterPopup
  //             isFilter={searchFilter.tempColumnSearch.title.isFiltered}
  //             searchField="Title"
  //             accessorKey="title"
  //           />
  //         </div>
  //       ),
  //       Cell: ({ cell }) => (
  //         <span
  //           className="table-row-content"
  //           style={{ wordBreak: "break-word" }}
  //         >
  //           {cell.getValue<string>()}
  //         </span>
  //       ),
  //     },
  //     {
  //       accessorKey: "category",
  //       header: "",
  //       maxSize: 80,
  //       Header: () => (
  //         <div>
  //           <span style={{ marginRight: "8px" }}>Category</span>
  //           <FilterPopup
  //             isFilter={searchFilter.tempColumnSearch.category.isFiltered}
  //             accessorKey="category"
  //           />
  //         </div>
  //       ),
  //       size: 80,
  //       Cell: ({ cell }) => {
  //         const category = cell.getValue<string>();
  //         let className = "category";

  //         if (category === "CRITICAL") {
  //           className += " critical";
  //         } else if (category === "TARGET") {
  //           className += " target";
  //         } else if (category === "GENERAL") {
  //           className += " general";
  //         }

  //         return <span className={className}>{category}</span>;
  //       },
  //     },
  //     {
  //       accessorKey: "createdBy",
  //       header: "",
  //       maxSize: 140,
  //       Header: () => (
  //         <div className="notify-table-align">
  //           <div>
  //             <span>Created By</span>

  //             <SearchFilterSort
  //               fieldName={DBTilte.createdBy}
  //               currentSortFieldName={apiQuery.sortField}
  //               isAscending={apiQuery.isAscending}
  //               onClick={handleSorting}
  //             />

  //             <SearchFilterSort
  //               fieldName={DBTilte.createdOn}
  //               currentSortFieldName={apiQuery.sortField}
  //               isAscending={apiQuery.isAscending}
  //               onClick={handleSorting}
  //             />
  //           </div>
  //           <FilterPopup
  //             isFilter={
  //               searchFilter.tempColumnSearch.createdBy.isFiltered ||
  //               searchFilter.tempColumnSearch.createdOn.isFiltered
  //             }
  //             searchField="Created By"
  //             accessorKey="createdBy"
  //           />
  //         </div>
  //       ),
  //       Cell: ({ cell }) => {
  //         const cellValue = cell.getValue<{ name: string; dateTime: string }>();
  //         const formattedDate = dayjs(cellValue.dateTime).format(
  //           "MMM DD, YYYY hh:mm:ss A"
  //         );
  //         return (
  //           <div>
  //             <Tooltip title={cellValue.name}>
  //               <div className="table-row-content">
  //                 {cellValue.name.slice(0, 18)}..
  //               </div>
  //             </Tooltip>
  //             <div className="timezone"> {formattedDate} </div>
  //           </div>
  //         );
  //       },
  //     },
  //     {
  //       accessorKey: "updatedBy",
  //       header: "",
  //       maxSize: 140,
  //       Header: () => (
  //         <div className="notify-table-align">
  //           <div>
  //             <span>Updated By</span>
  //             <SearchFilterSort
  //               fieldName={DBTilte.updatedBy}
  //               currentSortFieldName={apiQuery.sortField}
  //               isAscending={apiQuery.isAscending}
  //               onClick={handleSorting}
  //             />

  //             <SearchFilterSort
  //               fieldName={DBTilte.updatedOn}
  //               currentSortFieldName={apiQuery.sortField}
  //               isAscending={apiQuery.isAscending}
  //               onClick={handleSorting}
  //             />
  //           </div>
  //           <FilterPopup
  //             isFilter={
  //               searchFilter.tempColumnSearch.updatedBy.isFiltered ||
  //               searchFilter.tempColumnSearch.updatedOn.isFiltered
  //             }
  //             searchField="Updated By"
  //             accessorKey="updatedBy"
  //           />
  //         </div>
  //       ),
  //       Cell: ({ cell }) => {
  //         const cellValue = cell.getValue<{ name: string; dateTime: string }>();
  //         const formattedDate = cellValue.dateTime
  //           ? dayjs(cellValue.dateTime).format("MMM DD, YYYY hh:mm:ss A")
  //           : "-";
  //         return (
  //           <div>
  //             {" "}
  //             {cellValue.name ? (
  //               <>
  //                 <Tooltip title={cellValue.name}>
  //                   <div className="table-row-content">
  //                     {cellValue.name.slice(0, 18)}..
  //                   </div>
  //                 </Tooltip>
  //                 <div className="timezone"> {formattedDate} </div>
  //               </>
  //             ) : (
  //               <div style={{ textAlign: "center" }}>-</div>
  //             )}
  //           </div>
  //         );
  //       },
  //     },
  //     {
  //       accessorKey: "status",
  //       header: "",
  //       Header: () => (
  //         <div>
  //           <span style={{ marginRight: "8px" }}>Status</span>
  //           <FilterPopup
  //             isFilter={searchFilter.tempColumnSearch.status.isFiltered}
  //             accessorKey="status"
  //           />
  //         </div>
  //       ),
  //       size: 80,
  //       Cell: ({ cell }) => {
  //         let status = cell.getValue<string>();
  //         if (status === "WAITING_SENT_FOR_PUBLICATION") {
  //           status = "WAITING";
  //         }
  //         let className = "status";

  //         if (status === "DRAFT") {
  //           className += " draft";
  //         } else if (status === "WAITING") {
  //           className += " waiting";
  //         } else if (status === "PUBLISHED") {
  //           className += " pulished";
  //         } else if (status === "RECALL") {
  //           className += " recall";
  //         } else if (status === "SUBMITTED") {
  //           className += " submitted";
  //         }

  //         return (
  //           <div
  //             className={className}
  //             style={{ paddingTop: "23px !important" }}
  //           >
  //             {status}
  //           </div>
  //         );
  //       },
  //     },
  //   ],
  //   [handleSorting]
  // );

  // unselect the checkbox After assign the notification
  useEffect(() => {
    if (IsAssigned) {
      setRowSelection({});
    }
  }, [IsAssigned, GlobalLevel]);

  // define the cloumn header and values
  const columns = useNotificationColumns({
    apiQuery,
    searchFilter,
    handleSorting,
  });
  // define the table required actions
  const table = useMaterialReactTable({
    columns: columns,
    data: tableData,
    enableColumnActions: false,
    enableSorting: false,
    enableColumnFilterModes: false,
    enableFilters: false,
    enableFullScreenToggle: false,
    enableGlobalFilter: false,
    enableDensityToggle: false,
    enableHiding: false,
    enableRowActions: true,
    enableTableFooter: false,
    enablePagination: false,
    enableStickyHeader: true,
    enableSelectAll: MultipleAssign.selectionType !== "none" ? true : false,
    initialState: {
      density: "compact",
    },
    positionActionsColumn: "last",
    renderRowActions: ({ row }) => (
      <ActionButtons row={row.original} onEdit={handleUpdateNotification} />
    ),
    enableRowSelection: (row) => row.original.rowSelection?.visibility,
    getRowId: (row) => row.notificationID,
    onRowSelectionChange: setRowSelection,
    manualFiltering: true,
    state: { rowSelection, isLoading: isRefetching },

    muiTableBodyCellProps: {
      sx: {
        textAlign: "left",
        height: "47px",
        textWrap: "wrap",
      },
    },
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: "#F8F8F8",
        color: "#8e8e8e",
        textAlign: "left",
        fontFamily: "Inter",
        fontWeight: 500,
        fontSize: "14px",
        paddingTop: "10px",
        position: "sticky",
      },
    },
    muiTablePaperProps: {
      sx: {
        boxShadow: "none",
        border: "1px solid #d9d9d9",
        borderRadius: "5px",
        width: "100%",
        height: "calc(100% - 5px)",
        overflowY: "auto",
      },
    },
  });
  return (
    <>
      <MaterialReactTable table={table} />

      {enableViewNotification && (
        <div className="view-notification-wrapper">
          <ViewNotification />
        </div>
      )}
      {enableDeleteModal ? <DeleteNotification /> : ""}
      {enableAssignUser ? <AssignNotification /> : ""}
      {enableRecall && <RecallNotifications />}
    </>
  );
};
export default TableContent;
